<template>
    <div class="h-100">
        <b-container class="p-0" fluid>
            <b-row align-h="center">
                <b-col md="10">
                    <div class="d-flex align-items-center mb-2">
                        <h1 class="m-0">{{ $t("mainmenu.contacts") }}</h1>
                        <b-button id="popover-info" class="ml-1 p-0 info-square" size="sm" variant="primary">
                            i
                        </b-button>
                    </div>
                    <b-popover
                        :show.sync="popoverShow"
                        placement="bottom"
                        target="popover-info"
                        triggers="click blur"
                        variant="white"
                    >
                        <template #default>
                            <b-button
                                aria-label="secondary"
                                class="px-50 py-25 popover-close"
                                variant="light"
                                @click="onPopoverClose"
                            >
                                <span aria-hidden="true">&times;</span>
                            </b-button>
                            <h4>{{ $t("mainmenu.contacts") }}</h4>
                            <p class="text-secondary">
                                <small>{{ $t("contacts.intro1") }}</small>
                            </p>
                            <p class="text-secondary mb-0">
                                <small>{{ $t("contacts.intro2") }}</small>
                            </p>
                        </template>
                    </b-popover>

                    <b-tabs v-model="tabIndex" class="w-100">
                        <b-tab :active="route === 'contacts'" @click="tabIndex = 0">
                            <template #title>
                                <span>{{ $t("contacts.All contacts") }}</span>
                            </template>

                            <all-contacts />
                        </b-tab>
                        <b-tab :active="route === 'contacts-lists'" @click="tabIndex = 1">
                            <template #title>
                                <span>{{ $t("contacts.lists.contacts-lists") }}</span>
                            </template>

                            <lists />
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import allContacts from "./components/allContacts";
import lists from "./lists/lists";
import useContacts from "@/views/modules/contacts/useContacts";
import vSelect from "vue-select";
import { BButton, BCol, BContainer, BPopover, BRow, BTab, BTabs } from "bootstrap-vue";
import { ref, watch } from "@vue/composition-api";
import router from "@/router";

export default {
    components: {
        BButton,
        BCol,
        BContainer,
        BPopover,
        BRow,
        BTab,
        BTabs,
        allContacts,
        lists,
        vSelect,
    },

    setup() {
        const tabIndex = ref(0);
        const refTable = ref(null);
        const { count } = useContacts();

        /**
         * Popover info
         */
        const popoverShow = ref(false);
        const onPopoverClose = () => {
            popoverShow.value = false;
        };

        watch(tabIndex, (index) => {
            const routeIndexMap = {
                0: "contacts",
                1: "contacts-lists",
            };

            if (router.currentRoute.name === routeIndexMap[index]) {
                return;
            }

            router.replace({ name: routeIndexMap[index] });
        });

        return {
            count,
            onPopoverClose,
            popoverShow,
            refTable,
            tabIndex,
            route: router.currentRoute.name,
        };
    },
};
</script>

<style lang="scss">
@import "~@core/scss/vue/libs/vue-select.scss";
@import "~@/assets/scss/tabs.scss";
</style>
